import { commonViewTexts } from '../common';
import { createDialogCommonViewTexts } from './create-dialog-common';

const targetName = commonViewTexts.company;

export const createNewCompanyDialogViewTexts = {
  title: `${targetName} 新規登録`,
  descriptions: createDialogCommonViewTexts.messageGenerator(targetName),
  labels: {
    registerer: commonViewTexts.registerer,
    companyName: `${targetName}名`
  }
} as const;
